import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router";
import moment from 'moment';
import { notification, ConfigProvider, Button, Descriptions, Input, Checkbox, DatePicker, Popconfirm } from 'antd';
import ImgView from 'components/common/FileController/ImgView';
import FileUpload from 'components/common/FileController/FileUpload';
// import FileDownload from 'components/common/FileController/FileDownload';

import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
import "./NoticeDetail.scss";
moment.locale('ko');

class NoticeDetail extends Component {
  state = {
    saveData: {
      bodId: '',
      bodType: '',
      bodTitle: '',
      bodContent: '',
      bodHit: '',
      bodMakeUser: '',  //
      bodMakeDate: '',  //
      bodEditUser: '',  //
      bodEditDate: '',  //
      bodPopYn: 'N',
      bodPopStart: moment().format('YYYY-MM-DD'),
      bodPopEnd: moment().add(10, 'd').format('YYYY-MM-DD'),
      bodAttachedFile: '',
      bodAttachedList: []
    },
  };

  onChangValue = (dataVal, dataNm) => {
    if (dataNm === 'bodPopDate') {
      this.setState({
        saveData: {
          ...this.state.saveData,
          bodPopStart: dataVal[0].format('YYYY-MM-DD'),
          bodPopEnd: dataVal[1].format('YYYY-MM-DD'),
      }});
    } else {
      this.setState({
        saveData: {
          ...this.state.saveData,
          [dataNm]: dataVal
      }});
    }
  };

  setData = (mode) => {
    this.props.onViewMode(mode);
    if (mode === 'detail' || mode === 'add') {
      this.setState({
        saveData: {
          bodId: '',
          bodType: '',
          bodTitle: '',
          bodContent: '',
          bodHit: '',
          bodMakeUser: '',  //
          bodMakeDate: '',  //
          bodEditUser: '',  //
          bodEditDate: '',  //
          bodPopYn: 'N',
          bodPopStart: moment().format('YYYY-MM-DD'),
          bodPopEnd: moment().add(10, 'd').format('YYYY-MM-DD'),
          bodAttachedFile: '',
          bodAttachedList: [],
      }});
    } else if (mode === 'mod') {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ...this.props.detailData
      }});
    }
  };

  onSave = () => {
    if (this.state.saveData.bodTitle === '') {
      notification.warning({placement: 'bottomLeft', message: `제목을 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.bodContent === '') {
      notification.warning({placement: 'bottomLeft', message: `내용을 입력해주세요.`, duration: 2});
      return false;
    }
    
    if (this.props.viewMode === 'add') {
      this.props.addNoticeInfo(this.state.saveData);
    } else if (this.props.viewMode === 'mod') {
      this.props.modNoticeInfo(this.state.saveData);
    }
  };

  onAttachedFile = (fileData) => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        bodAttachedList: this.state.saveData.bodAttachedList.concat(fileData)
      }
    });
  };

  onRemove = (fileId) => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        bodAttachedList: this.state.saveData.bodAttachedList.filter(element => element.fileId !== fileId)
    }});
  };

  render() {
    const { viewMode, detailData, delNoticeInfo, sessionLoginInfo } = this.props;
    const { saveData } = this.state;
    return (
      <Fragment>
        <h2 className="h2_t">공지사항
        {viewMode === 'detail' && <Fragment> 상세보기</Fragment>}
        {viewMode === 'add' && <Fragment> 추가</Fragment>}
        {viewMode === 'mod' && <Fragment> 수정</Fragment>}
        </h2>
        <div className="board_btn_r">
          {(sessionLoginInfo !== null 
            && sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
            && (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
              || sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER))
            ? 
            (viewMode === 'detail'
            ? <Fragment>
                <Button 
                  type="primary"
                  onClick={()=>this.setData('mod')}
                >수정</Button>
                &nbsp;&nbsp;
                <Popconfirm 
                  title="삭제하시겠습니까?"
                  onConfirm={() => delNoticeInfo(detailData.bodId)}
                  onClick={(e)=>e.stopPropagation()}
                >
                  <Button 
                    type="primary"
                  >삭제</Button>
                </Popconfirm>
                &nbsp;&nbsp;
                <Button 
                  type="primary"
                  onClick={()=>this.setData('list')}
                >목록</Button>
              </Fragment>
            : <Fragment>
                <Button 
                  type="primary"
                  onClick={()=>this.onSave()}
                >저장</Button>
                &nbsp;&nbsp;
                <Button 
                  type="primary"
                  onClick={()=>this.setData(viewMode === 'add' ? 'list' : 'detail')}
                >취소</Button>
              </Fragment>
            )
          : <Button 
              type="primary"
              onClick={()=>this.setData('list')}
            >목록</Button>
          }
        </div>
        <div className="table_th_W">
          <Descriptions bordered>
            {viewMode === 'detail' &&
            <Fragment>
              <Descriptions.Item label="NO">
                {detailData !== null && detailData.bodId !== undefined && detailData.bodId !== null && detailData.bodId}
              </Descriptions.Item>
              <Descriptions.Item label="작성일">
                {detailData !== null && detailData.bodMakeDate !== undefined && detailData.bodMakeDate !== null && detailData.bodMakeDate}
              </Descriptions.Item>
              <Descriptions.Item label="조회수">
                {detailData !== null && detailData.bodHit !== undefined && detailData.bodHit !== null && detailData.bodHit}
              </Descriptions.Item>
            </Fragment>
            }
            <Descriptions.Item label="제목" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.bodTitle !== undefined && detailData.bodTitle !== null && detailData.bodTitle)
              : <Input
                  value={saveData.bodTitle}
                  onChange={(e)=>this.onChangValue(e.target.value, 'bodTitle')}
                />
              }
            </Descriptions.Item>
            <Descriptions.Item label="내용" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.bodContent !== undefined && detailData.bodContent !== null && detailData.bodContent) &&
                <div className="min-hight-300">
                  {detailData.bodContent.split(`\n`).map((item, idx)=>{
                    return (
                      <Fragment key={idx}>
                        {item}
                        {detailData.bodContent.split(`\n`).length > idx+1 && <br />}
                      </Fragment>
                  )})}
                </div>
              : <Input.TextArea className="height-300" 
                  autoSize={true}
                  value={saveData.bodContent}
                  onChange={(e)=>this.onChangValue(e.target.value, 'bodContent')}                 
                />
              }
            </Descriptions.Item>
            <Descriptions.Item label="팝업공지" span={3}>
              {viewMode === 'detail'
              ? <Fragment>
                  <Checkbox
                    disabled={true}
                    checked={(detailData !== null && detailData.bodPopYn !== undefined && detailData.bodPopYn !== null &&
                      detailData.bodPopYn === 'Y') ? true : false}
                  >팝업여부</Checkbox>

                  {(detailData !== null && detailData.bodPopStart !== undefined && detailData.bodPopStart !== null 
                    && detailData.bodPopEnd !== undefined && detailData.bodPopEnd !== null) &&
                  <ConfigProvider locale={koKr}>
                    <DatePicker.RangePicker
                      disabled={true}
                      format={'YYYY-MM-DD'}
                      allowClear={false}
                      value={[moment(detailData.bodPopStart), moment(detailData.bodPopEnd)]}
                    />
                  </ConfigProvider>
                  }
                </Fragment>
              : <Fragment>
                  <Checkbox 
                    checked={saveData.bodPopYn === 'Y' ? true : false}
                    onChange={(e)=>this.onChangValue(e.target.checked ? 'Y' : 'N', 'bodPopYn')}
                  >팝업여부</Checkbox>
                  <ConfigProvider locale={koKr}>
                    <DatePicker.RangePicker
                      format={'YYYY-MM-DD'}
                      allowClear={false}
                      value={[moment(saveData.bodPopStart), moment(saveData.bodPopEnd)]}
                      onChange={(date, dateString)=>{
                        // console.log('date: ', date);
                        this.onChangValue(date, 'bodPopDate');
                      }}
                    />
                  </ConfigProvider>
                </Fragment>
              }
            </Descriptions.Item>
            <Descriptions.Item label="첨부파일" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.bodAttachedList !== undefined && detailData.bodAttachedList !== null) &&
                (<Fragment>
                  {detailData.bodAttachedList.map((item,idx)=>{
                    return(
                      <Fragment key={idx}>
                        <ImgView
                          fileInfo={{
                            fileId: item.fileId,
                            fileName: item.fileName,
                            physicalName: item.physicalName,
                            serverSubPath: item.serverSubPath,
                          }}
                          width={'100%'}
                          height={'100%'}
                        />
                        {item.fileName !== undefined && item.fileName !== null && item.fileName}
                        {idx !== detailData.bodAttachedList.length && <br />}
                      </Fragment>
                    );
                  })}
                </Fragment>)
              : <Fragment>
                  <div style={{float:'right',color: '#f00'}}>이미지만 업로드 가능합니다.</div> 
                  <FileUpload
                    //imgSizeCheck={true}
                    fileType={'img'}
                    onFileInfo={(fileData)=>this.onAttachedFile(fileData)}
                  />
                  {(saveData !== null && saveData.bodAttachedList !== undefined && saveData.bodAttachedList !== null) &&
                    saveData.bodAttachedList.map((item,idx)=>{
                    return(
                      <Fragment key={idx}>
                        <ImgView
                          fileInfo={{
                            fileId: item.fileId,
                            fileName: item.fileName,
                            physicalName: item.physicalName,
                            serverSubPath: item.serverSubPath,
                          }}
                          width={100}
                          height={100}
                        />
                        {item.fileName !== undefined && item.fileName !== null && item.fileName}
                        <span
                          style={{ margin: 8, color: 'red' }}
                          onClick={()=>this.onRemove(item.fileId)}
                        >X</span>
                        {idx !== saveData.bodAttachedList.length && <br />}
                      </Fragment>
                    );
                  })}
                </Fragment>
              }
            </Descriptions.Item>
          </Descriptions>
        </div>
      </Fragment>
    );
    
  }
}

export default withRouter(NoticeDetail);
